import React from 'react';


// Shown by Bootstrap (data-bs-target="#copyModal") after a "Copy Link" button copies a link.
export default function CopyModal() {
  return (
    <div className="modal fade" id="copyModal" tabIndex="-1" aria-labelledby="copyModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="copyModalLabel">Link Copied</h1>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
            Your link has been copied to your clipboard and is ready to paste.
          </div>
        </div>
      </div>
    </div>
  );
}
